module.exports = __webpack_public_path__ + "img/p_sz_5.98443be8.svg";